import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { validatePassword } from 'shared';
import { EmailInput, FieldGroup, PasswordInput, Stack } from 'library/ui';
import FormSection from './FormSection';

interface AccountSectionProps {
    email: string;
    isEmail: boolean;
    onEmailChange: (value: string, isValid: boolean) => void;
    password: string;
    isPassword: boolean;
    passwordErrorText: string;
    onPasswordChange: (value: string, isValid: boolean) => void;
    expanded: boolean;
    complete: boolean;
    onToggle: () => void;
    onNext: () => void;
}

export default function AccountSection({
    email,
    onEmailChange,
    password,
    onPasswordChange,
    expanded,
    complete,
    onToggle,
    onNext,
}: AccountSectionProps) {
    return (
        <FormSection
            title="Account"
            subtitle="Create your login credentials"
            icon={<LockIcon />}
            expanded={expanded}
            complete={complete}
            onToggle={onToggle}
            onNext={onNext}
            autoFocusId="signup-email"
        >
            <Stack gap="md" fullWidth>
                <FieldGroup label="Email*">
                    <EmailInput id="signup-email" value={email} onChange={onEmailChange} fullWidth />
                </FieldGroup>
                <FieldGroup label="Create Password*">
                    <PasswordInput
                        id="signup-password"
                        value={password}
                        onChange={(value) => onPasswordChange(value, validatePassword(value))}
                        fullWidth
                        showRequirements
                    />
                </FieldGroup>
            </Stack>
        </FormSection>
    );
}
